// extracted by mini-css-extract-plugin
export default {"componentHolder":"HandleMoney_componentHolder__qaDXe","actionPart":"HandleMoney_actionPart__7IY0Y","amount":"HandleMoney_amount__Pjkok","sendBtn":"HandleMoney_sendBtn__l4Tk-"};